import React from 'react';

import styles from './userBadgesPageStyles.scss';

import BadgeCard from '@buyside/components/presentation/UserAccount/YourBadges/badgeCard';
import LoadingSpinner, {
  SIZES
} from '@buyside/components/presentation/LoadingSpinner/loadingSpinner';

import { chunk } from '@buyside/util/arrayHelper';

import { useCurrentUserAccountBadgesQuery } from '@interfaces/graphql-typings';

const UserBadgesPage = (): React.ReactElement => {
  const { loading, data } = useCurrentUserAccountBadgesQuery();

  if (loading || !data?.currentUser) return <LoadingSpinner size={SIZES.LARGE} />;

  const { userBadges, unearnedBadges } = data.currentUser;

  const sortedUserBadges = userBadges?.edges?.length
    ? [...userBadges.edges].sort((a, b): number => {
        if (!a || !b || !a.node || !b.node || !a.node.badge || !b.node.badge) return 0;
        return a.node.badge.order - b.node.badge.order;
      })
    : [];
  const earnedTableRows = sortedUserBadges.length ? chunk(sortedUserBadges, 2) : [];
  const unearnedTableRows = unearnedBadges?.length ? chunk(unearnedBadges, 2) : [];

  return (
    <>
      <div className={styles.pageTitle}>Your Badges</div>
      {sortedUserBadges.length ? (
        <table className={styles.badgeTable}>
          <tbody>
            {earnedTableRows.map((row, idx) => {
              return (
                <tr key={idx}>
                  {row.map(edge => {
                    return (
                      <td key={edge?.node?.id}>
                        <BadgeCard badgeInfo={edge?.node} earned />
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : null}
      {!sortedUserBadges.length ? (
        <div className={styles.unearnedMsg}>
          See below to find out how to earn badges for your profile.
        </div>
      ) : null}
      {unearnedTableRows.length ? (
        <div>
          <h4 className={styles.pageSubsectionTitle}>Unearned Badges</h4>
          <table className={styles.badgeTable}>
            <tbody>
              {unearnedTableRows.map((row, idx) => {
                return (
                  <tr key={idx}>
                    {row.map(badge => {
                      return (
                        <td key={badge?.id}>
                          <BadgeCard badgeInfo={badge} earned={false} />
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : null}
    </>
  );
};

export default UserBadgesPage;
